import {AfterViewInit, Component, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {SwiperComponent, SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-detail-slider',
  templateUrl: './detail-slider.component.html'
})
export class DetailSliderComponent implements AfterViewInit {

  @Input() data;

  public galleryTopConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 1,
    simulateTouch: false,
    pagination: {
      el: '.slider-detail-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        if (current < 10) {
          if (total < 10) {
            return '0' + current + ' / ' + '0' + total;
          } else {
            return '0' + current + ' / ' + total;
          }
        } else {
          return current + ' / ' + total;
        }
      }
    },
    breakpoints: {
      1350: {
        simulateTouch: true,
      },
    }
  };

  public galleryThumbsConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 5,
    spaceBetween: 6,
    breakpoints: {
      1350: {
        slidesPerView: 7
      },
      550: {
        slidesPerView: 5
      }
    }
  };

  @ViewChild('galleryTop', { static: true }) galleryTop: SwiperComponent;
  @ViewChild('galleryThumbs', { static: true }) galleryThumbs: SwiperComponent;

  constructor() { }

  ngAfterViewInit() {}

  public slideToPrev() {
    if(this.galleryTop.directiveRef.swiper().activeIndex === 0) {
      const newIndex = this.galleryTop.directiveRef.swiper().slides.length - 1;
      this.galleryTop.directiveRef.swiper().slideTo(newIndex);
    } else {
      this.galleryTop.directiveRef.swiper().slidePrev();
    }

    for(var i=0; i<this.galleryThumbs.directiveRef.swiper().slides.length; i++) {
      this.galleryThumbs.directiveRef.swiper().slides[i].classList.remove('swiper-slide-active');
    }
    this.galleryThumbs.directiveRef.swiper().slides[this.galleryTop.directiveRef.swiper().activeIndex].classList.add('swiper-slide-active');
  }

  public slideToNext() {
    if(this.galleryTop.directiveRef.swiper().activeIndex === this.galleryTop.directiveRef.swiper().slides.length - 1) {
      this.galleryTop.directiveRef.swiper().slideTo(0);
    } else {
      this.galleryTop.directiveRef.swiper().slideNext();
    }
    for(var i=0; i<this.galleryThumbs.directiveRef.swiper().slides.length; i++) {
      this.galleryThumbs.directiveRef.swiper().slides[i].classList.remove('swiper-slide-active');
    }
    this.galleryThumbs.directiveRef.swiper().slides[this.galleryTop.directiveRef.swiper().activeIndex].classList.add('swiper-slide-active');
  }

  public updateThumbs() {
    const currentIndex = this.galleryTop.directiveRef.swiper().activeIndex;

    this.galleryThumbs.directiveRef.swiper().activeIndex = currentIndex;

    for(var i=0; i<this.galleryThumbs.directiveRef.swiper().slides.length; i++) {
      this.galleryThumbs.directiveRef.swiper().slides[ i ].classList.remove('swiper-slide-active');
    }

    this.galleryThumbs.directiveRef.swiper().slides[currentIndex].classList.add('swiper-slide-active');
  }

  public changeToIndex(index) {
    this.galleryTop.directiveRef.swiper().params.control = this.galleryThumbs.directiveRef.swiper().slideTo(index, 500);
    this.galleryThumbs.directiveRef.swiper().params.control = this.galleryTop.directiveRef.swiper().slideTo(index, 500);

    for(var i=0; i<this.galleryThumbs.directiveRef.swiper().slides.length; i++) {
      this.galleryThumbs.directiveRef.swiper().slides[i].classList.remove('swiper-slide-active');
    }
    this.galleryThumbs.directiveRef.swiper().clickedSlide.classList.add('swiper-slide-active');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    setTimeout(() => {this.galleryTop.directiveRef.update(); this.galleryThumbs.directiveRef.update(); }, 500);
  }

}
